import "./popup.css";

const Popup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-box" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={onClose}>×</button>

        <h4 className="mb-2">Let's Get Connected</h4>
        <p>
          Get free consultation for Online Account Management, Listing,
          Advertising & Growth 🚀
        </p>

        <a
          href="tel:+918527203697"
          className="btn btn-warning w-100 mt-3"
        >
          Call Now +91 85272 03697
        </a>

        <a
          href="/Contact"
          className="btn btn-outline-dark w-100 mt-2"
        >
          Enquiry Form
        </a>
      </div>
    </div>
  );
};

export default Popup;
